import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Table, Modal, Button, Form, ProgressBar } from 'react-bootstrap';
import { FaPlus, FaCheck, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaUniversalAccess, FaUser, FaFileImport, FaSearch, FaTools, FaQuestionCircle, FaRegQuestionCircle, FaArrowRight, FaArrowLeft, FaTrashAlt } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../../dashboard/sidebar'
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';

const Defaillants = ({ titre }) => {
    useAuth();
    const existingAcces = { acces: [] }; // Ensure this is defined

    const [qcms, setQcms] = useState([]);
    const [selectedQcm, setSelectedQcm] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [successMessage, setSuccessMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);


    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Nombre d'éléments par page
    const totalItems = qcms.length;  // Si 'formationList' contient toutes les formations

    const location = useLocation();

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | QCM"; // Définit le titre de la page
        }
    }, [user_id]);


    const [selectedFile, setSelectedFile] = useState(null);
    const [filteredQcms, setFilteredQcms] = useState([]);
    const [qcmsDefaillant, setQcmsDefaillant] = useState(0);



    const listeQcmDefaillants = async () => {
        let dataComplet = [];
        setIsLoading(true)
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/verifier-integrite-qcm/');
            const data = await response.json();
            const nombre_reponses_incoherentes = data.nombre_reponses_incoherentes;
            const nombre_options_manquantes = data.nombre_options_manquantes;
            const nombre_reponses_vides = data.nombre_reponses_vides;
            const nombre_sans_version_anglaise = data.nombre_sans_version_anglaise;

            if (response.ok) {
                // setQcmsDefaillant(nombre_reponses_incoherentes + nombre_options_manquantes + nombre_reponses_vides + nombre_sans_version_anglaise)
                setQcms(data.anomalies)
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }finally{
            setIsLoading(false)
        }
    };

    useEffect(() => {
        listeQcmDefaillants();
    }, []);


    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            listeQcmDefaillants(); // Mettez à jour les données sans recharger la page
        }, 7000);
    };

    const handleRowClick = (qcm) => {
        setSelectedQcm(qcm);
    };

    // Utiliser useEffect pour récupérer et afficher le message après redirection
    useEffect(() => {
        if (successMessage) {
            const timer = setTimeout(() => {
                setSuccessMessage('');
            }, 5000);

            // Nettoyage du timer lors du démontage
            return () => clearTimeout(timer);
        }
    }, []);


    useEffect(() => {
        const filtered = qcms.filter(qcm =>
            qcm.question.includes(searchTerm) || qcm.domaine.includes(searchTerm)
        );
        setFilteredQcms(filtered);
        setCurrentPage(1); // Reset to first page when search term changes
    }, [searchTerm, qcms]);

    const sortedQcms = [...filteredQcms].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Pagination logic
    const indexOfLastQcm = currentPage * itemsPerPage;
    const indexOfFirstQcm = indexOfLastQcm - itemsPerPage;
    const currentQcms = sortedQcms.slice(indexOfFirstQcm, indexOfLastQcm);
    const totalPages = Math.ceil(sortedQcms.length / itemsPerPage);

    // Gestion du changement d'éléments par page
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1); // Reset current page to 1
    };

    const handleModifier = (qcm) => {
        if (qcm) {
            navigate(`/Modifier-qcm`, {
                state: { qcm_id: qcm.id, qcm_ref: qcm.unicite_fr },
            });
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("QCM")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                                                                    <Link to="/" className="btn btn-primary">
                                                                                        <i className="fa fa-arrow-left mr-2"></i>
                                                                                        Retour
                                                                                    </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaRegQuestionCircle size={25} className='mr-2' /> Gestion des QCMs défallants</h2>
                            <small>Administration des QCMs défallants.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/Liste-qcm`}> QCM</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <span> Qcm-défallants</span>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="">
                            <div className="d-flex flex-column justify-content-between flex-md-row mt-3 mt-md-0">
                                <h5>Liste des QCM défallants</h5>
                                <div className="d-flex flex-column flex-sm-row flex-wrap mt-3 mb-3 mt-md-0" style={{ gap: '10px' }}>
                                    <div className='d-flex'>
                                        <button
                                            onClick={() => handleModifier(selectedQcm)}
                                            disabled={!selectedQcm}
                                            className={`btn mb-2 mb-md-0 ms-md-2 mr-2 ${selectedQcm ? 'btn-success' : 'btn-default text-dark'}`}
                                        >
                                            <FaEdit /> Modifier
                                        </button>
                                        <Link to="/Liste-qcm" className="btn btn-success mb-2 mb-md-0 ms-md-2 mr-2">
                                            <FaArrowLeft /> Retour
                                        </Link>
                                    </div>
                                </div>
                            </div>


                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}

                            <div className='row'>
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                {/* <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control col-md-3"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                /> */}
                                            </div>
                                            <div className="table-responsive">
                                                <table
                                                    className="footable table table-stripped footable-loaded tablet breakpoint"
                                                    data-page-size="8"
                                                    data-filter="#filter"
                                                    style={{
                                                        width: '100%',
                                                        tableLayout: 'fixed',  // Fixe la largeur des colonnes pour éviter l'overflow
                                                        overflowX: 'hidden',   // Cache tout ce qui déborde horizontalement
                                                    }}>
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ width: '10%' }} onClick={() => handleSort('id')}>
                                                                Id{sortConfig.key === 'id'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ width: '10%' }} onClick={() => handleSort('ref')}>
                                                                Ref{sortConfig.key === 'ref'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ width: '50%' }} onClick={() => handleSort('question')}>
                                                                Question {sortConfig.key === 'question'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ width: '20%' }} onClick={() => handleSort('commentaire')}>
                                                                Commentaire {sortConfig.key === 'commentaire'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!isLoading ? (
                                                            currentQcms.map((qcm) => (
                                                                <tr
                                                                    key={qcm.id}
                                                                    className={`bg-white ${selectedQcm && selectedQcm.id_fr === qcm.id_fr ? 'bg-success text-white' : ''}`}
                                                                    onClick={() => handleRowClick(qcm)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    <td className="d-none d-md-table-cell">{qcm.id_fr}</td>
                                                                    <td className="d-none d-md-table-cell">{qcm.ref}</td>
                                                                    <td className="d-none d-md-table-cell" style={{ wordBreak: "break-word", whiteSpace: "normal", maxWidth: "200px" }}>
                                                                        <span dangerouslySetInnerHTML={{ __html: qcm.question }}></span>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell" style={{ wordBreak: "break-word", whiteSpace: "normal", maxWidth: "200px" }}>{qcm.commentaire}</td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <div className="mt-3 d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
                                                                <span
                                                                    className="spinner-border spinner-border-lg text-success"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                    style={{ width: '3rem', height: '3rem' }}
                                                                ></span>
                                                            </div>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>


                                            {/* Pagination Controls */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                {/* <div className="dataTables_info" role="status" aria-live="polite">
                                                    {`Élément ${indexOfFirstQcm + 1} à ${Math.min(indexOfLastQcm, totalItems)} sur ${totalItems}`}
                                                </div> */}
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstQcm + 1} à ${Math.min(indexOfLastQcm, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5; // Nombre total de pages à afficher
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        // Ajuster le startPage si la fin dépasse le total des pages
                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        // Ajout des boutons de pages
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    {/* Bouton pour aller à la dernière page */}
                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Styles CSS pour les cellules fixes */}
            <style jsx>{`
                width: 300px; /* Ajustez cette valeur selon vos besoins */
                overflow: hidden; /* Évite le débordement de contenu */
                text-overflow: ellipsis; /* Ajoute des "..." pour le contenu tronqué si nécessaire */
                word-wrap: break-word; /* Permet au texte de s'enrouler et de casser les mots longs */
                overflow-wrap: break-word; /* Ajoute cette propriété pour la compatibilité */
                white-space: normal; /* Permet le retour à la ligne */
            `}</style>
        </div>
    );
};

export default Defaillants;
